import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "asp-order box-flex-column" }

import AverageOrderList from '../components/average-order-list.vue';
import ContinuousOrderList from '../components/continuous-order-list.vue';
import { computed, ref } from 'vue';
import { BaseTabs, BaseTabPane, BaseLayoutFlexContent } from 'xrk-components';
import { useRoute, useRouter } from 'vue-router';
import { resource } from '@/utils';

export default /*#__PURE__*/_defineComponent({
  __name: 'tax-withholding',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const tabs = computed(() => {
  return [
    resource.checkPermission('一般劳务') && {
      label: '一般劳务',
      value: '2'
    },
    resource.checkPermission('连续劳务') && {
      label: '连续劳务',
      value: '3'
    }
  ].filter(Boolean);
});

const pageType = ref(tabs.value[0].value);
const setPageType = () => {
  if (route.query.orderNo) {
    // 清除路由上的查询参数
    router.replace({
      query: { force: Date.now() }
    });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseTabs), {
      onClick: setPageType,
      modelValue: pageType.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pageType).value = $event))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (item) => {
          return (_openBlock(), _createBlock(_unref(BaseTabPane), {
            label: item.label,
            name: item.value,
            key: item.value
          }, null, 8, ["label", "name"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(BaseLayoutFlexContent), null, {
      default: _withCtx(() => [
        (pageType.value === '2')
          ? (_openBlock(), _createBlock(AverageOrderList, {
              key: 0,
              style: {"height":"100%"}
            }))
          : _createCommentVNode("", true),
        (pageType.value === '3')
          ? (_openBlock(), _createBlock(ContinuousOrderList, {
              key: 1,
              style: {"height":"100%"}
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})